module.exports = __webpack_public_path__ + "img/social-media-window.b0fdfa47.png";